import axios from 'axios'
import humps from 'humps'
import { store } from '../store'
import { signOut } from 'actions/auth'
import { clearUserSession } from 'actions/userSession'

const API_URL = process.env.REACT_APP_API_URL
const UUID_REGEX = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/

const createAxiosClient = () => {
  const { getState, dispatch } = store
  const userSession = getState().auth.userSession
  let headers = {}
  if (userSession) {
    const { accessToken, uid, client } = userSession
    headers = { 'access-token': accessToken, uid, client }
  }

  const client = axios.create({
    baseURL: API_URL,
    headers,
    transformRequest: [
      data => humps.decamelizeKeys(data),
      ...axios.defaults.transformRequest
    ],
    transformResponse: [
      ...axios.defaults.transformResponse,
      data => humps.camelizeKeys(data, (key, convert) => (
        UUID_REGEX.test(key) ? key : convert(key)
      ))
    ]
  })

  client.interceptors.response.use(
    response => response,
    error => {
      if (!error.response) {
        return Promise.reject({ errors: ["Couldn't connect to SixPence."] })
      } else {
        const { status: errorStatus } = error.response
        if (errorStatus === 401) {
          dispatch(clearUserSession())
        } else if (errorStatus === 403) {
          dispatch(signOut())
        }
        // TODO: Improve handling for cases where validation errors (422) are not caught directly in component
        // e.g. for form field feed back. this should be a backup. probably needs to get extracted to middleware
        return Promise.reject(error.response)
      }
    }
  )

  return client
}

export default createAxiosClient
